import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const ProgressThermometer = ({ totalSteps = 0, currentStep = 0 }) => {
  const stepArray = Array.from({ length: totalSteps }, (v, i) => i + 1);
  const ariaLabel = `Progress thermometer chart showing ${totalSteps} items, with item ${currentStep} highlighted`;
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const percentWidth = ((currentStep - 1) / (totalSteps - 1)) * 100;
    if (percentWidth < 0) setWidth(0);
    else if (percentWidth > 100) setWidth(100);
    else setWidth(percentWidth);
  }, [totalSteps, currentStep]);

  return (
    <>
      <ul className="et-progress-thermometer" aria-label={ariaLabel}>
        {stepArray.map(step => (
          <li key={step} aria-label="progress point">
            <div
              className={classNames(
                "et-progress-thermometer--remaining-step",
                { "et-progress-thermometer--active-step": step === currentStep },
                { "et-progress-thermometer--completed-step": step < currentStep }
              )}
            ></div>
          </li>
        ))}
      </ul>
      <div className="et-progress-thermometer--line--outer">
        <div className="et-progress-thermometer--line--inner" style={{ width: width + "%" }} />
      </div>
    </>
  );
};

ProgressThermometer.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default ProgressThermometer;
